import api from "../Utils/axios";
import { adminV1Base } from "../Utils/connection_strings";
import { filterParams } from "../Utils/helpers";

export const getCategories = (page, perPage, search_string, status, from, to) => {
    return api.get(`${adminV1Base}/category/get`, {
        params: filterParams({
            page,
            limit: perPage,
            keyword: search_string,
            active: status,
            "createdAt[from]": from,
            "createdAt[to]": to,
        }),
    });
};

export const getCategoryDetails = (id) => {
    return api.get(`${adminV1Base}/category/get`, {
        params: {
            _id: id,
        },
    });
};

export const createCategory = (data) => {
    return api.post(`${adminV1Base}/category/create`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

export const editCategory = (data) => {
    return api.post(`${adminV1Base}/category/edit`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

export const handleCategoryStatus = (id) => {
    return api.post(`${adminV1Base}/category/handle-status`, { id });
};

export const deleteCategory = (id) => {
    return api.post(`${adminV1Base}/category/delete`, { id });
};
